"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginController = function () {
  function LoginController(AuthService, NavigationService, AppContextService, EventsService, $state) {
    'ngInject';

    (0, _classCallCheck3.default)(this, LoginController);
    this.authService = AuthService;
    this.navigationService = NavigationService;
    this.appContextService = AppContextService;
    this.eventsService = EventsService;

    this.username = '';
    this.password = '';
    this.verificationCode = '';
    this.errorMessage = '';
    this.isLoading = false;
    this.loginText = 'Verify';
    this.phase = 1;
  }

  (0, _createClass3.default)(LoginController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this.eventsService.listen(_constants2.default.events.VERIFICATION_CODE_RECEIEVED, function (e, args) {
        console.log(args);
        _this.verificationCode = args;
        _this.submit();
      });
    }
  }, {
    key: "submit",
    value: function submit(e) {
      if (e) e.preventDefault();

      this.isLoading = true;
      this.loginText = 'Checking...';

      if (this.phase === 1) {
        var payload = {
          userName: this.username,
          password: this.password
        };
        this.authService.initiateLogin(payload, this._onInitiateLoginSuccess.bind(this), this._onInitiateLoginFailure.bind(this));
      } else {
        var _payload = {
          userName: this.username,
          password: this.password,
          verificationCode: this.verificationCode
        };
        this.authService.login(_payload, this._onLoginSuccess.bind(this), this._onLoginFailure.bind(this));
      }
    }
  }, {
    key: "_onInitiateLoginSuccess",
    value: function _onInitiateLoginSuccess(response) {
      this.setErrorMessage("");

      this.isLoading = false;
      this.loginText = 'Login';

      this.phoneNumber = response.data.phoneNumber;
      this.phase = 2;

      setTimeout(function () {
        document.getElementById("verificationCode").focus();
      }, 500);
    }
  }, {
    key: "_onInitiateLoginFailure",
    value: function _onInitiateLoginFailure(error) {
      console.log("Initiate login failed:", error.data.message);

      this.isLoading = false;
      this.loginText = 'Verify';

      this.setErrorMessage("Invalid username or password.");
    }
  }, {
    key: "_onLoginSuccess",
    value: function _onLoginSuccess(response) {
      var _this2 = this;

      this.setErrorMessage("");

      this.appContextService.fetchAppContext(function (response) {
        var roles = response.data.roles;
        if (_this2.appContextService.hasAccess(roles)) {
          _this2.appContextService.setAppContext(response.data);
          var defaultState = _env2.default.defaultState();
          _this2.navigationService.go(defaultState);

          // Let the world know that you have access to bigfoot! yaay!!
          _this2.eventsService.broadcast(_constants2.default.events.AUTHORIZATION_SUCCESS);
        } else {
          _this2.setErrorMessage("You are not authorized to access this application.");
        }
      }, function () {
        _this2.setErrorMessage("You are not authorized to access this application.");
      });
    }
  }, {
    key: "_onLoginFailure",
    value: function _onLoginFailure(error) {
      console.log("Login failed:", error.data.message);

      this.isLoading = false;
      this.loginText = 'Login';

      this.setErrorMessage("Invalid verification code.");
    }
  }, {
    key: "setErrorMessage",
    value: function setErrorMessage(error) {
      this.errorMessage = error;
      this.isLoading = false;
    }
  }]);
  return LoginController;
}();

exports.default = LoginController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/login/login.controller.js
 **/